
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/parascolastico/[slug]",
      function () {
        return require("private-next-pages/parascolastico/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/parascolastico/[slug]"])
      });
    }
  